function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_14",
  "data-name": "Group 14",
  transform: "translate(-709 -234)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_6",
  "data-name": "Ellipse 6",
  transform: "translate(709 234)",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 7.5,
  r: 7.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 7.5,
  r: 7,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar-add",
  transform: "translate(712.25 237.25)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_113",
  "data-name": "Rectangle 113",
  width: 7,
  height: 6.067,
  rx: 0.5,
  transform: "translate(0.75 1.683)",
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_40",
  "data-name": "Line 40",
  x2: 7,
  transform: "translate(0.75 3.55)",
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_41",
  "data-name": "Line 41",
  y1: 1.633,
  transform: "translate(2.617 0.75)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_42",
  "data-name": "Line 42",
  y1: 1.633,
  transform: "translate(5.883 0.75)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.1fc47d04.svg";
export { ForwardRef as ReactComponent };